<script setup>
import { useSiteBrand } from '../../composables/useSiteBrand.js';

const { siteName } = useSiteBrand();
</script>

<template>{{ siteName }}</template>
